import { apiClient } from '../api/client'

export type ContactType = 'bug' | 'question' | 'feature' | 'other'

export interface ContactSubmission {
  type: ContactType
  subject: string
  body: string
  pageUrl?: string
}

export interface ContactResponse {
  id: string
  created_at: string
}

class ContactService {
  async submit(payload: ContactSubmission): Promise<ContactResponse> {
    return apiClient.post('/contact', payload)
  }
}

export const contactService = new ContactService()
